module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjM4Mjk1IDcuNjQ2NTRDNi45ODYyMSA4LjA4Mjc2IDYuMzAwMSA4LjA4Mjc2IDUuOTAzMzYgNy42NDY1M0wwLjY2MTMzOCAxLjg4Mjc5QzAuMDc3MTU2NyAxLjI0MDQ2IDAuNTMyODkzIDAuMjA5OTYgMS40MDExNCAwLjIwOTk2TDExLjg4NTIgMC4yMDk5NjFDMTIuNzUzNCAwLjIwOTk2MSAxMy4yMDkxIDEuMjQwNDcgMTIuNjI1IDEuODgyNzlMNy4zODI5NSA3LjY0NjU0WiIgZmlsbD0iIzUwNTA1MCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/chooseDrop.svg
// module id = 0NDe
// module chunks = 0